import { ChevronRightIcon } from "@/components/icons";

/**
 * Resumen del razonamiento del modelo. Va plegado: es contexto útil cuando
 * algo sale raro, pero no es la respuesta.
 */
export function Reasoning({ text }: { text: string }) {
  if (text.trim() === "") return null;

  return (
    <details className="group text-sm text-muted-foreground">
      <summary className="flex cursor-pointer list-none items-center gap-1.5">
        <ChevronRightIcon className="size-3.5 transition-transform group-open:rotate-90" />
        Razonamiento
      </summary>
      <p className="mt-1 border-l-2 pl-3 whitespace-pre-line">{text}</p>
    </details>
  );
}
